module.exports = __webpack_public_path__ + "static/d.60c4ceb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./res/TopGallery/d.jpg
// module id = 292
// module chunks = 114276838955818